// funciones reutilizables para imagenes
import notImg from '../assets/not-image.png'
export const notImageMixin = {
  methods: {
    setAltImg(event) { 
      event.target.src = notImg
    }, 
  }
}